<script lang="ts">
  import { getDialog, initDialog } from '$lib/dialogs';
  import './globals.css';
  import SessionBar from './SessionBar.svelte';
  import { Icon } from '@steeze-ui/svelte-icon';
  import { XCircle } from '@steeze-ui/heroicons';
  import Signin from '$lib/components/session/Signin.svelte';
  import ForgotPassword from '$lib/components/session/ForgotPassword.svelte';
  import Signup from '$lib/components/session/Signup.svelte';
  import type { LayoutData } from './$types';
  import { invalidateAll } from '$app/navigation';
  import { session } from '$lib/stores';
  import { logError } from '$lib/utils';
  import { onMount } from 'svelte';
  import { websocketClient } from '$lib/WebSocket';
  import { PUBLIC_APP_HOST } from '$env/static/public';

  export let data: LayoutData;

  $: session.set(data.session);

  initDialog();

  const dialog = getDialog();
  const closeDialog = () => ($dialog = null);
  const acceptTOS = async () => {
    const res = await fetch('/api/accept-tos', {
      method: 'POST'
    });

    if (res.status == 200) {
      invalidateAll();
    } else {
      logError(res);
    }
  };

  onMount(() => {
    websocketClient();
    window.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && $dialog != null) {
        closeDialog();
      }
    });
  });
</script>

{#if data.maintenance}
  <slot />
{:else}
  <header class="flex flex-col">
    <div class="relative">
      <div class="absolute inset-0 shadow z-30 pointer-events-none" />
      <div class="relative z-20">
        <div class="px-4 sm:px-6 lg:px-8 mx-auto max-w-7xl md:space-x-10">
          <div class="flex justify-between items-center">
            <SessionBar />
          </div>
        </div>
      </div>
    </div>
  </header>

  <slot />

  {#if $dialog != null}
    <dialog open={true}>
      <div class="relative z-30" aria-labelledby="modal-title" role="dialog" aria-modal={true}>
        <div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity">
          <div class="fixed z-10 inset-0 overflow-y-auto">
            <div class="flex items-end sm:items-center justify-center min-h-full p-4 sm:p-0">
              <div
                class="relative bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all max-w-lg w-full p-6 sm:my-8"
                role="presentation"
                on:click|stopPropagation
                on:keyup
              >
                {#if $dialog == 'forgot-password'}
                  <ForgotPassword />
                {:else if $dialog == 'signin'}
                  <Signin />
                {:else if $dialog == 'signup'}
                  <Signup />
                {/if}
                <div class="mt-5 sm:mt-6 text-center">
                  <button
                    type="button"
                    on:click={closeDialog}
                    class="group inline-flex text-sm font-medium align-center"
                  >
                    <Icon src={XCircle} theme="solid" class="h-4 w-4 mr-2 text-gray-500" />
                    <span class="text-gray-500 group-hover:text-gray-700">Cerrar</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </dialog>
  {/if}

  {#if !data.tos_accepted}
    <div
      class="lg:sticky text-sm lg:bottom-0 left-0 right-0 h-auto lg:h-24 bg-gray-700 text-white flex"
    >
      <div
        class="flex gap-4 flex-col justify-center items-center w-full max-w-7xl p-5 lg:flex-row m-auto"
      >
        <div>
          Para utilizar la plataforma debes estar de acuerdo y aceptar la privacidad, térmnos y
          condiciones.
        </div>
        <div class="flex flex-col gap-4 justify-center items-center w-full lg:max-w-xl lg:flex-row">
          <button
            data-testid="tos-banner:accept"
            class="uppercase bg-primary-500 hover:bg-primary-400 rounded px-4 py-2 whitespace-nowrap flex w-full lg:w-1/2 justify-center"
            on:click={acceptTOS}
          >
            Acepto
          </button>
          <a
            data-testid="tos-banner:view"
            class="uppercase bg-primary-500 hover:bg-primary-400 rounded px-4 py-2 whitespace-nowrap flex w-full lg:w-1/2 justify-center"
            href="/terminos-y-condiciones-de-uso"
          >
            Política de privacidad
          </a>
        </div>
      </div>
    </div>
  {/if}
{/if}

{#if !PUBLIC_APP_HOST.includes('localhost')}
  <!-- Google tag (gtag.js) -->
  <script async src="https://www.googletagmanager.com/gtag/js?id=G-JWCND9HE1M"></script>
  <script>
    window.dataLayer = window.dataLayer || [];
    function gtag() {
      dataLayer.push(arguments);
    }
    gtag('js', new Date());

    gtag('config', 'G-JWCND9HE1M');
  </script>
{/if}
